import React, { memo, useCallback, useState } from 'react';
import { Icon } from 'antd';
import { StyledTalContentRelatedWrapper } from '../../../styled-components/product/try-aibility/tal-content-related';

const TalContentRelated = memo(() => {
  const data = [
    {
      input: '你最喜欢的小动物是什么呢？说说你为什么喜欢它！',
      options: [
        {
          text: '我喜欢的小动物是小企鹅，小企鹅胖嘟嘟的圆鼓鼓的。所以我喜欢它，它走路的时候是摇摇摆摆，所以我喜欢它。',
          score: '相关',
          isGood: 1
        },
        {
          text: '不能小于15秒，妈妈什么意思？',
          score: '不相关',
          isGood: 0
        }
      ]
    },
    {
      input:
        '请你介绍一种课上学到的传统游戏，简单介绍一下游戏规则，或与之有关的人物故事！',
      options: [
        {
          text: '我今天要介绍一种游戏，是斗鸡斗鸡，是古时候人类常玩的一种游戏，就是雪鸡，然后在上面，网上嗯，接着，然后互相着打。',
          score: '相关',
          isGood: 1
        },
        {
          text: '我要怎么样啊，我就尽量做好吧，好好，我不，跟你烦了。',
          score: '不相关',
          isGood: 0
        }
      ]
    },
    {
      input: '小朋友，你的心愿是什么呢？请你说一说吧！',
      options: [
        {
          text: '还是少一人死亡。',
          score: '不相关',
          isGood: 0
        },
        {
          text: '我的心愿是买很多很多，我喜欢的玩具，那样，我就可以天天玩那些玩具了，真可开心啊',
          score: '相关',
          isGood: 1
        }
      ]
    }
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentData, setCurrentData] = useState(data[currentIndex]);
  const [selectOption, setSelectOption] = useState(currentData.options[0]);
  const handleOptionClick = useCallback((option) => {
    setSelectOption(option);
  }, []);

  const handleRandomInstance = useCallback(() => {
    setCurrentIndex((c) => {
      if (c + 1 >= data.length) {
        c = 0;
      } else {
        c += 1;
      }
      setCurrentData(data[c]);
      setSelectOption(data[c].options[0]);
      return c;
    });
  }, [data]);

  return (
    <StyledTalContentRelatedWrapper>
      <div className="refresh-demo" onClick={() => handleRandomInstance()}>
        <Icon type="sync" />
        <span>换一个实例</span>
      </div>
      <div className="demo-content">
        <div className="demo-input">{currentData.input}</div>
        <div className="demo-result">
          <ul className="demo-options">
            {currentData.options.map((option) => {
              return (
                <li onClick={() => handleOptionClick(option)} key={option.text}>
                  <a
                    className={
                      option.text === selectOption.text
                        ? 'selected btn-normal'
                        : 'btn-normal'
                    }
                  >
                    {option.text}
                  </a>
                </li>
              );
            })}
          </ul>
          <div className="demo-score">
            <small className="demo-score-desc">
              说明：该结果表明选项内容与题干的相关度（只包含相关与不相关）
            </small>
            <div
              className={
                selectOption.isGood === 1
                  ? 'demo-score-detail good'
                  : 'demo-score-detail bad'
              }
            >
              {selectOption.score}
            </div>
          </div>
        </div>
      </div>
    </StyledTalContentRelatedWrapper>
  );
});

export default TalContentRelated;
